const rowsPerPageBasedOnViewport = () => {
    //@ts-ignore
    const windowInnerHeight = document.documentElement.clientHeight;
    let heightTable = windowInnerHeight - 300;

    let rowHeight = 48;
    const rows = Math.floor(heightTable / rowHeight);
    return rows > 0 ? rows : 1;
}

export default rowsPerPageBasedOnViewport;